module.exports = __webpack_public_path__ + "static/media/minus-circle.b43a1458.svg";